// extracted by mini-css-extract-plugin
export default {"Content":"ChangeFullView_Content__dsxTd","ForceAcceptDelegateButton":"ChangeFullView_ForceAcceptDelegateButton__gvTT+"};